import { ENVIRONMENT_TOKEN, Environment } from '@actassa/api';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { isEmpty } from 'lodash-es';
import { Observable, finalize, of, tap } from 'rxjs';

import { TimesheetHourBreakV3 } from '../interfaces/timesheet-hour-break-v3.interface';
import { AbstractDataLoader } from '../../../abstracts/data-loader.service';

@Injectable()
export class TimesheetHourBreaksService extends AbstractDataLoader {
    constructor(
        @Inject(ENVIRONMENT_TOKEN) protected readonly environment: Environment,
        private readonly http: HttpClient,
    ) {
        super(environment);
    }

    public load$(timesheetHourIds: Array<string>): Observable<Array<TimesheetHourBreakV3>> {
        if (isEmpty(timesheetHourIds)) {
            return of([]);
        }

        this.startLoading();

        const params = new HttpParams({ fromObject: { timesheetHourIds } });
        const url = this.buildUrl('v3/timesheet/hour/breaks');

        return this.http.get<Array<TimesheetHourBreakV3>>(url, { params })
            .pipe(
                tap(() => this.stopLoading()),
                finalize(() => this.stopLoading()),
            );
    }
}
